<template>
  <PageHeader title="Scholarship Application"></PageHeader>
  <v-container>
    <v-form validate-on="submit" @submit.prevent="submitEII">
      <v-card>
        <v-card-text>
          <h3>Application Information</h3>
          <div class="d-inline-flex ga-4 pa-2">
            <p>
              This application information is used to calculate sliding scale
              scholarships for the Junior Program based on household information
              and income information. Applicants should be prepared to provide
              income verification upon request by Community Boating.
            </p>
          </div>
          <h3>Household Information</h3>
          <div class="d-inline-flex ga-4 pa-2">
            <v-number-input
              label="Working Adults"
              width="250"
              v-model="eiiResponse.workingAdults"
            />
            <v-number-input
              label="Dependent Adults"
              width="250"
              v-model="eiiResponse.nonWorkingAdults"
            />
            <v-number-input
              label="Children"
              width="250"
              v-model="eiiResponse.children"
            />
          </div>
          <h3>Income Information</h3>
          <p>
            Houshold income should match form 1040/1040SR box 11 on your most
            recent return.
          </p>
          <div class="d-inline-flex ga-4 pa-2">
            <CurrencyInput
              label="Household Adjusted Gross Income"
              width="250"
              v-model:amount-cents="eiiResponse.householdIncomeCents"
              hide-controls
              :rules="[rules.required]"
            />
          </div>
          <h3>Scholarship Terms</h3>
          <div>
            <p>
              I understand CBI offers need-based scholarships to junior member
              families to uphold its mission of Sailing for All. By applying for
              a CBI scholarship, I am affirming that all information provided
              about my family make-up and household income is true and accurate.
              I also understand that CBI reserves the right to require
              documentation at any point in the application process.
            </p>
            <v-checkbox
              v-model="termsAgreed"
              label="I agree to the terms of the scholarship application."
            ></v-checkbox>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="outlined" @click="backToYouthMemberships"
            >Cancel Application</v-btn
          >
          <v-btn
            type="submit"
            color="primary"
            :loading="loading"
            :disabled="!termsAgreed"
            >Submit Application</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-container>
</template>
<script lang="ts" setup>
import { useRouter } from "vue-router";
import { useValidation } from "@/composables/useValidation";
import { SubmitEventPromise } from "vuetify";
import type { EiiApplicationRequest } from "../../../cbi-generator/generated/dto/EiiApplicationRequest";
import { useEiiService } from "../../../cbi-generator/frontend/composables/useEiiFrontendService";
const rules = useValidation();
const router = useRouter();
const termsAgreed = ref(false);
const loading = ref(false);
const eiiResponse = ref<EiiApplicationRequest>({
  householdIncomeCents: 0,
  children: 1,
  workingAdults: 1,
  nonWorkingAdults: 0,
});
function backToYouthMemberships() {
  router.push({ name: "youth-memberships" });
}
async function submitEII(a: SubmitEventPromise) {
  const result = await a;
  if (!result.valid) return false;
  loading.value = true;
  try {
    await useEiiService().submitApplicationMember(eiiResponse.value);
    backToYouthMemberships();
  } finally {
    loading.value = false;
  }
}
</script>
